<template>
  
  <div class="service-panel">
    <div class="waitress-box" @click="show = true">
      <div class="mainbox">

        <img src="../assets/images/watress.png" alt="" class="avatar">
        <div  class="status">
          <span class="name">{{customerService && customerService.name || "客服"}}</span>
          <van-rate v-model="rate" :size="13" :count="count" disabled disabled-color="rgb(255, 210, 30)"/>
        </div>
      </div>
      <div class="contactbox">
        <span class="contact"> <van-icon name="phone" /> 联系客服</span>
      </div>
    </div>
    <van-dialog v-model="show" >
      <a :href="phone(item.tel)" v-for="(item, index) in actions" :key="index" class="phone-action">拨打电话：{{item.name}}</a>
    </van-dialog>
  </div>


</template>

<script>
import {
  Icon, Rate, Popup, Dialog, List
} from "vant";
import Vue from 'vue'
Vue.use(Dialog);

export default {
  props: {
     customerService: {},
     rate: {
       type: [Number],
       default: 5
     },
     count: {
       type: [Number],
       default: 5
     }
  },
  name: 'service-contact',
  components: {
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
    [List.name]: List,
    [Rate.name]: Rate
  },
  data () {
    return {
      msg: '客服',
      show: false,
      actions: [
        {name: `137 1881 4588`, tel: "13718814588"},
        {name: `010-52423230`, tel: "01052423230"},
      ]
    }
  },
  mounted() {
    
  },
  methods: {
    tel() {
      return (this.customerService && this.customerService.phone) || "4006056006";
    },
    onSelect(item) {
      location.href = `tel:${item.tel}`;
      this.show = false;
    },
    phone(num) {
      return `tel:${num}`;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  @import "../assets/less/var.less";

  .phone-action {
    display: block;
    text-align: center;
    padding: 10px 0px;
    border-bottom: 1px #F2F2F2 solid;
  }

  .waitress-box {
    padding: 10px;
    display: flex;
    background-color: white;
    border-top: 1px solid #f2f2f2;
    border-bottom: 1px solid #f2f2f2;

    .mainbox {
      flex: 1;
      display: flex;
      &>img {
        width: 40px;
        height: 40px;
        display: inline-block;
        vertical-align: middle;
        
      }
      .status {
        margin-left: 10px;
        vertical-align: middle;
  
        .name {
          display: block;
          font-size: 13px;
          color: @defaultTitleColor;
        }
      }
    }

    .contactbox {
      display: flex;

      .contact {
        display: inline-block;
        vertical-align: middle;
        color: @defaultTitleColor;
        margin: auto;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/sby-service-contact.vue